import { render, staticRenderFns } from "./MatterPlaintiffForm.vue?vue&type=template&id=36729ddc&"
import script from "./MatterPlaintiffForm.vue?vue&type=script&lang=js&"
export * from "./MatterPlaintiffForm.vue?vue&type=script&lang=js&"
import style0 from "./MatterPlaintiffForm.vue?vue&type=style&index=0&id=36729ddc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports